export const pad = (n) => String(n).padStart(2, "0");
export const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const toMin = (hm) => Number(hm.slice(0, 2)) * 60 + Number(hm.slice(3, 5));
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
export const startOfWeek = (d) => { const x = new Date(d); const day = (x.getDay() + 6) % 7; x.setDate(x.getDate() - day); x.setHours(0, 0, 0, 0); return x; };
export const fmtDay = (d) => d.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" });

export const EVENT_STYLES = {
  confirmed: "border-green-500 bg-green-50 text-green-900",
  pending_payment: "border-amber-500 bg-amber-50 text-amber-900",
  pending_approval: "border-sky-500 bg-sky-50 text-sky-900 border-dashed",
  blocked: "border-slate-500 bg-slate-100 text-slate-700 bg-[repeating-linear-gradient(45deg,transparent,transparent_6px,rgba(100,116,139,0.12)_6px,rgba(100,116,139,0.12)_12px)]",
};

export const LEGEND = [
  ["confirmed", "Confirmed"], ["pending_payment", "Awaiting payment"],
  ["pending_approval", "Pending approval"], ["blocked", "Blocked"],
];
